var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-layout',{staticClass:"layout-default",attrs:{"id":"layout-default"}},[_c('full-page-header'),_c('a-layout-content',[_c('router-view')],1),_c('full-page-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }